var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDualUsersIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38095 3C8.38095 4.65683 7.01646 6 5.33333 6C3.65018 6 2.28571 4.65683 2.28571 3C2.28571 1.34315 3.65018 0 5.33333 0C7.01646 0 8.38095 1.34315 8.38095 3ZM11.8095 5.25C13.2823 5.25 14.4762 4.07475 14.4762 2.625C14.4762 1.17525 13.2823 0 11.8095 0C10.3368 0 9.14286 1.17525 9.14286 2.625C9.14286 4.07475 10.3368 5.25 11.8095 5.25ZM16 8.25C16 9.49268 14.1239 10.5 11.8095 10.5C11.5181 10.5 11.2336 10.484 10.9589 10.4537C11.2606 10.1246 11.4286 9.75945 11.4286 9.375C11.4286 8.31892 10.1615 7.4085 8.33478 6.99195C9.08785 6.39345 10.3631 6 11.8095 6C14.1239 6 16 7.00733 16 8.25ZM5.33333 12C8.27886 12 10.6667 10.8247 10.6667 9.375C10.6667 7.92525 8.27886 6.75 5.33333 6.75C2.38782 6.75 0 7.92525 0 9.375C0 10.8247 2.38782 12 5.33333 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualUsersIconSm);
export default __webpack_public_path__ + "static/media/dualUsersIconSm.db1c8ad55e79f44f8f423b11ba0fffb5.svg";
export { ForwardRef as ReactComponent };